<template>
  <div class="fixed" :class="{ 'fixed-shadow': suspension }">
    <div class="main-header">
      <div class="main-header-width">
        <span>
          <router-link tag="a" :to="{ name: 'Home' }">{{ headerName }}</router-link>
        </span>
        <ul class="main-top-info">
          <li>
            <router-link tag="a" :to="{ name: 'Center' }">{{ account }}</router-link>
          </li>
          <li>
            <router-link tag="a" :to="{ name: 'Order' }">
              <i class="header-order-icon"></i>订单
            </router-link>
          </li>
          <li>
            <router-link tag="a" :to="{ name: 'Wallet' }">
              <i class="header-order-icon header-wallet-icon"></i>我的钱包
            </router-link>
          </li>
          <li>
            <router-link tag="a" :to="{ name: 'DownloadList' }">
              <i class="header-order-icon header-download-icon"></i>下载列表
            </router-link>
          </li>
          <li style="border: 0;">
            <router-link tag="a" :to="{ name: 'Document' }">
              <i class="header-order-icon header-document-icon"></i>功能文档
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div
      class="main-isbill"
      v-if="$route.path == '/index/home' || $route.path == '/index/category'"
    >
      <el-switch class="float-right" v-model="isBill" :width="74" on-text="含税" off-text="不含税" on-color="#ffa726" off-color="#91d446" @change="changeIsBill"></el-switch>
      <div class="boxtj">
        显示商品
        <button
          @click="changeIsBill(0)"
          class="btns"
          :class="{add : isbtn == 0}"
          style="margin-left: 10px"
        >全部</button>
        <button @click="changeIsBill(2)" class="btns" :class="{add : isbtn == 2}" ref="ao2">含税</button>
        <button @click="changeIsBill(1)" class="btns" :class="{add : isbtn == 1}" ref="ao0">不含税</button>
      </div>
    </div> -->
    <div class="main-search">
      <div class="main-search-logo">
        <router-link tag="a" :to="{ name: 'Home' }" :style="{ backgroundImage: 'url(' + logoUrl + ')' }"></router-link>
      </div>
      <div class="main-search-content" style="width: 650px">
        <ul class="main-search-type">
          <li v-for="(item, index) in tab" @click="searchType" :data-id="index" :class="{ 'select': item.position == position }">
            {{ item.tabtext }}</li>
        </ul>
        <div class="main-search-input">
          <div v-if="tab[0].isShow">
            <input type="text" placeholder="输入商品名称" v-model="keyword" @keyup.enter="submitForm(tab[0].position)" />
          </div>
          <div v-else-if="tab[1].isShow">
            <input type="text" placeholder="输入商品名称" v-model="keyword" @keyup.enter="submitForm(tab[1].position)" />
          </div>
          <div v-else>
            <input type="text" placeholder="" v-model="keyword" />
          </div>
          <router-link tag="div" class="main-search-btn"
            :to="{ name: 'Category', query: { levelOne: '', levelTwo: '', levelThree: '', keyWord: keyword, selectType: selectType, brandId: '', position: position } }">搜
            索</router-link>
        </div>
        <!-- <div class="hot-search">
          <ul v-show="tab[0].isShow">
            <li v-for="item in hotGoodsWord">
              <router-link
                tag="a"
                :to="{name: 'Category', query: { levelOne: '', levelTwo: '', levelThree: '', keyWord: item, selectType: '1', brandId: '' }}"
              >{{item}}</router-link>
            </li>
          </ul>
          <ul v-show="tab[1].isShow">
            <li v-for="item in hotBrandWord">
              <router-link
                tag="a"
                :to="{name: 'Category', query: { levelOne: '', levelTwo: '', levelThree: '', keyWord: item, selectType: '1', brandId: '' }}"
              >{{item}}</router-link>
            </li>
          </ul>
        </div> -->
      </div>
      <div class="main-spp-car" style="width: 300px;text-align: right;">
        <router-link style="display: inline-block;margin-right: 10px;" tag="div" class="main-spp-car-shape"
          :to="{ name: 'PriceLibraryGoods' }">
          <i class="main-library-icon"></i>
          报价篮子
        </router-link>
        <router-link style="display: inline-block;" tag="div" class="main-spp-car-shape" :to="{ name: 'Shelves' }">
          <i class="main-car-icon"></i>
          我的货架
          <!-- <span v-bind:class="{'display-none': goodsCountShow}">{{goodsCount}}</span> -->
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { CHANGE_IS_BILL } from "../store/mutations-type.js";

export default {
  data() {
    return {
      tab: [
        {
          selectType: 1,
          position: 1,
          tabtext: "全库商品",
          isShow: true,
          id: 1
        },
        {
          selectType: 1,
          position: 2,
          tabtext: "自营商品库",
          isShow: false,
          id: 2
        },
        // {
        //   tabtext: '标签',
        //   isShow: false,
        //   id: 3
        // }
      ], //搜索条件
      keyword: "", // 关键字
      selectType: 1, // 搜索类型
      position: (this.$route.query.position || 1),
      suspension: false,
      isBill: 0, //当前的含税按钮的状态
      isbtn: 0,
      logoUrl: this.$store.state.logoUrl,
      headerName: this.$store.state.headerName,
    };
  },
  computed: {
    ...mapState([
      "hotGoodsWord",
      "hotBrandWord",
      "goodsCount",
      "goodsCountShow",
      "account"
    ])
  },
  watch: {
    // 如果路由有变化，会再次执行该方法
    $route: "routeChange"
  },
  created() {
    //判断当前的含税的状态与仓库中进行比较
    this.keyword = this.$route.query.keyWord;
    if (this.isBill == this.$store.state.isBill) {
      this.isBill = false;
    } else {
      this.isBill = true;
    }
  },
  mounted() {
    if (this.$store.state.isBill == 0) {
      this.isbtn = 0;
      this.$store.commit(CHANGE_IS_BILL, 0); //全部
    } else if (this.$store.state.isBill == 1) {
      this.isbtn = 1;
      this.$store.commit(CHANGE_IS_BILL, 1); //不含税
    } else if (this.$store.state.isBill == 2) {
      this.isbtn = 2;
      this.$store.commit(CHANGE_IS_BILL, 2); //含税
    } else {
      this.isbtn = 0;
    }
    // this.setHotGoodsWord();
    // this.setHotBrandWord();
    // this.setGoodsCount();
    window.addEventListener("scroll", this.handleScroll);
  },
  updated() {
    if (this.$store.state.isBill == 0) {
      this.isbtn = 0;
      this.$store.commit(CHANGE_IS_BILL, 0); //全部
    } else if (this.$store.state.isBill == 1) {
      this.isbtn = 1;
      this.$store.commit(CHANGE_IS_BILL, 1); //不含税
    } else if (this.$store.state.isBill == 2) {
      this.isbtn = 2;
      this.$store.commit(CHANGE_IS_BILL, 2); //含税
    } else {
      this.isbtn = 0;
    }
  },
  methods: {
    ...mapActions(["setHotGoodsWord", "setHotBrandWord", "setGoodsCount"]),
    searchType: function (event) {
      var tab = this.tab;
      var id = event.target.dataset.id;
      for (var i in tab) {
        if (i == id) {
          tab[i].isShow = true;
          this.selectType = tab[i].selectType;
          this.position = tab[i].position;
        } else {
          tab[i].isShow = false;
        }
      }
      // if (id == 2) {
      //   this.$router.push({
      //     name: 'CategoryLabel',
      //     query: {
      //       // levelOne: '',
      //       // levelTwo: '',
      //       // levelThree: '',
      //       // keyWord: '',
      //       // selectType: 3,
      //       // brandId: '',
      //     }
      //   });
      // }
    },
    handleScroll: function () {
      var h = document.documentElement.scrollTop || document.body.scrollTop;
      if (h > 0) {
        this.suspension = true;
      } else {
        this.suspension = false;
      }
    },
    hotSetInput(str) {
      this.keyword = str;
    },
    routeChange() {
      this.keyword = this.$route.query.keyWord;
    },
    changeIsBill(bill) {
      // 查看页面价格是否含税
      if (bill === 0) {
        this.isbtn = 0;
        this.$store.commit(CHANGE_IS_BILL, 0); //全部
      } else if (bill === 1) {
        this.isbtn = 1;
        this.$store.commit(CHANGE_IS_BILL, 1); //不含税
      } else if (bill === 2) {
        this.isbtn = 2;
        this.$store.commit(CHANGE_IS_BILL, 2); //含税
      }
    },
    submitForm(position) {
      //路由状态的跳转
      this.$router.push({
        path: "/index/Category",
        query: {
          levelOne: "",
          levelTwo: "",
          levelThree: "",
          keyWord: this.keyword,
          selectType: this.selectType,
          brandId: "",
          position: position
        }
      });
    }
  }
};
</script>
<style scoped>
.boxtj {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 11px;
}

.btns {
  width: 50px;
  height: 24px;
  border: 1px solid #e5e5e5;
  outline: none;
  background: #ffffff;
  color: #999999;
}

.add {
  background: #fea923;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// Header.vue?cb29fcb8